import { useState } from 'react';
import { AlertType, AlertSystemReturn } from '../types';

export function useAlertSystem(): AlertSystemReturn {
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState<AlertType>('success');
  const [customAlertMessage, setCustomAlertMessage] = useState<string | null>(null);

  const showSuccessAlert = (message: string) => {
    setAlertType('success');
    setCustomAlertMessage(message);
    setShowAlert(true);
  };

  const showErrorAlert = (message: string) => {
    setAlertType('error');
    setCustomAlertMessage(message);
    setShowAlert(true);
  };

  const showWarningAlert = (message: string) => {
    setAlertType('warning');
    setCustomAlertMessage(message);
    setShowAlert(true);
  };

  const showInfoAlert = (message: string) => {
    setAlertType('info');
    setCustomAlertMessage(message);
    setShowAlert(true);
  };

  const hideAlert = () => {
    setShowAlert(false);
    setCustomAlertMessage(null);
  };

  const getAlertMessage = (
    isSavingSearch: boolean,
    isSavingColumns: boolean,
    showSavedColumns: boolean,
    isSavingScore: boolean,
  ): string => {
    if (customAlertMessage) return customAlertMessage;

    if (alertType === 'success') {
      if (isSavingSearch) return 'Search saved successfully!';
      if (isSavingColumns) return 'Column selection saved successfully!';
      if (showSavedColumns) return 'Column selection loaded successfully!';
      if (isSavingScore) return 'Score saved successfully!';
      return 'Successfully downloaded!';
    }
    if (alertType === 'error') {
      if (isSavingSearch) return 'Error saving search. Please try again.';
      if (isSavingColumns) return 'Error saving column selection. Please try again.';
      if (isSavingScore) return 'Error saving score. Please try again.';
      return 'Error downloading file.';
    }
    if (alertType === 'warning') {
      return 'Download is being processed.';
    }
    return '';
  };

  return {
    showAlert,
    alertType,
    customAlertMessage,
    showSuccessAlert,
    showErrorAlert,
    showWarningAlert,
    showInfoAlert,
    hideAlert,
    getAlertMessage,
  };
}
